import { loadable } from '@change-corgi/core-react/loadable';

import type { AppRoute } from '#src/shared/routes';

import { Loading, petitionDecisionMaker } from '#src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'decision-maker-response-create',
		path: '/p/:slug/responses/new',
		component: loadable(async () => import(/* webpackChunkName: "pages/decisionMaker-response-create" */ './index'), {
			exportName: 'DecisionMakerResponseCreate',
			fallback: Loading,
		}),
		frame: true,
		priority: 10,
		restrictedAccess: {
			authOnly: true,
			role: petitionDecisionMaker('slug', {
				allowHash: true,
				dmHashParam: 'response',
			}),
		},
		ssr: {
			// switch this to true to enable SSR
			enabled: true,
			seo: false,
		},
	},
];
